<template>
  <div class="portal-wrapper">
    <main class="portal-main">
      <TheHeader />
      <div class="container py-5 mx-auto">
        <div
          v-if="statistic"
          class="px-2 grid gap-6 mb-8 md:grid-cols-2 xl:grid-cols-3"
        >
          <div class="xs-card__wrapper">
            <p
              v-for="(categoryProducts, key) in statistic.categoryProductCount"
              :key="key"
            >
              {{ key }}: {{ categoryProducts }} Products
            </p>
          </div>
          <div class="xs-card__wrapper">
            <p v-if="statistic.avgPrice">
              Products average price: {{ statistic.avgPrice.toFixed(2) }}€
            </p>
            <br />
            <p>Products complete value: {{ statistic.productsValue }}€</p>
          </div>
        </div>
        <div class="portal-navigation-buttons">
          <UiButton
            class="portal-navigation-buttons-btn"
            text="Products"
            @click.native="routeTo('PortalProducts')"
          />
          <UiButton
            class="portal-navigation-buttons-btn"
            text="Categories"
            color="yellow"
            @click.native="routeTo('PortalCategories')"
          />
        </div>
        <hr class="mt-4" />
        <router-view />
      </div>
    </main>
  </div>
</template>

<script>
import TheHeader from '@/components/layout/portal/TheHeader.vue'
import UiButton from '@/components/ui/portal/UiButton'
import { getStatistic } from '@/services/api/statistic.js'

export default {
  components: {
    TheHeader,
    UiButton
  },
  data() {
    return {
      statistic: null
    }
  },
  methods: {
    routeTo(name) {
      this.$router.push({
        name
      })
    }
  },
  mounted() {
    getStatistic().then(response => {
      this.statistic = response.statistic
    })
  }
}
</script>
<style lang="sass">
.portal-wrapper
    background: #f4f4f4
    @apply min-h-screen
.portal-navigation-buttons
    @apply flex w-full justify-evenly
    &-btn
      @apply w-1/2 mx-2 justify-center

@screen md
    .portal-navigation-buttons
        @apply text-center flex-row
        &-btn
            @apply mx-2

.xs-card
  &__wrapper
      @apply flex flex-col p-4 bg-white rounded-lg shadow-md
  &__title
      @apply mb-2 text-3xl font-medium text-gray-600
  &__slot
    @apply flex flex-col
    p
      @apply mb-2 text-3xl font-medium text-gray-600
</style>
